import React from 'react';
import {Grid} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import {makeStyles} from "@material-ui/core/styles";
import rice from './image 9.png'
import {loc, phone_green, dollor,} from '../../../assets/images/images'
import { APP_DOMAIN_PREFIX } from '../../../environment';


const useStyles = makeStyles({
  root: {
    marginBottom: 30,
    background: 'transparent'
  },
  discountText: {
    background: '#FF1E6F',
    padding: 5,
    color: '#fff',
    borderRadius: 5
  }
});

function Index(props) {
  const classes = useStyles();
  return (

    <Card className={classes.root}>
      <div className='display-flex  align-items-center justify-content-center  p-main  ' style={{}}>
        <div style={{width: '50%'}}>
          <img alt={''} src={props.item && props.item.imgPath ? APP_DOMAIN_PREFIX + "/userImages/" + props.item.imgPath : rice} className='best-seller-carousel-img ' height={300} style={{height: 300}}/>
        </div>
        <div className='pl-20  ' style={{maxWidth: '45%', marginLeft: '10%'}}>
          <h2 className='heading-color word-break '>{props?.item?.agriBusinessId?.agriBusinessName}</h2>
          <p className='font-12'>{props?.item?.agriServiceDescription}</p>

          <Grid container direction='column' alignItems=''>

            <Grid style={{}}>
              <Grid container alignItems='center'>
                <img src={loc} alt='youtube'/>
                <p className='ml-10 font-12'>{props?.item?.serviceArea}</p>
              </Grid>
              <Grid container alignItems='center' spacing={0}>
                <img src={phone_green} alt='call'/>

                <p className='ml-10 font-12'>{props?.item?.contactNumber}</p>
              </Grid>
              <Grid container alignItems='center' spacing={0}>
                <img src={dollor} alt='$ '/>

                <p className='ml-10 font-12'>{props?.item?.currency}  {props?.item?.serviceCharges} </p>
              </Grid>
            </Grid>
          </Grid>


          <Grid container direction='row' style={{flexWrap: 'nowrap',}} className='mt-20 mb-20'>
            {/* <Grid>
              <button className='buy-btn bg-discount heading-color bg-gray' style={{}}>Contact Provider</button>
            </Grid> */}
            {/* <Grid className='ml-10'>
              <button className='buy-btn heading-color text-bold'>make offer</button>
            </Grid> */}
          </Grid>
        </div>

      </div>
    </Card>

  );
}

export default Index;
